import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { Tabs } from '@cinch-nx/shared-ui'
import { CarsCarousel } from '@cinch-nx/storyblok'
import { StoryblokRenderer } from '@cinch-nx/storyblok-utils'
import { SbBlokData } from '@storyblok/react'
import React, { useEffect } from 'react'

const tabButtonTrackingEvent = (tabLabel: string) => ({
  eventName: `Tabbed Carousel Component`,
  type: TrackingEventTypes.ADOBE,
  data: {
    event: {
      name: EventNames.click,
      category: 'New Users Tabbed Carousel Component',
      label: `${tabLabel} tab`,
      action: 'Tab Clicked',
    },
  },
})

type NewAndUsedVehiclesProps = {
  usedCarsCarouselTab: SbBlokData
  newCarsCarouselTab: SbBlokData
}

export const NewCustomerTabs: React.FC<NewAndUsedVehiclesProps> = ({
  usedCarsCarouselTab,
  newCarsCarouselTab,
}) => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      trackEvent({
        eventName: 'New user module',
        type: TrackingEventTypes.PAGE,
        data: {
          event: {
            category: 'new-user-module',
            label: 'new-user-tabbed-carousel-component',
            action: 'triggered',
            name: 'load',
          },
        },
      })
    }, 3000)
    return () => clearTimeout(timeoutId)
  }, [trackEvent])

  return (
    <Tabs
      ariaLabel="used-and-new-cars-list"
      content={[
        {
          label: 'Used cars',
          onTabClick: () => trackEvent(tabButtonTrackingEvent('Used cars')),
          panelContent: (
            <StoryblokRenderer
              block={usedCarsCarouselTab}
              components={{ CarsCarousel }}
            />
          ),
        },
        {
          label: 'New cars',
          onTabClick: () => trackEvent(tabButtonTrackingEvent('New cars')),
          panelContent: (
            <StoryblokRenderer
              block={newCarsCarouselTab}
              components={{ CarsCarousel }}
            />
          ),
        },
      ]}
    />
  )
}
